import React, {useState, useRef} from "react"
import { CSSTransition } from 'react-transition-group';
import '../css/Top.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faCaretDown, faCaretUp, faUser, faSignOut  } from '@fortawesome/free-solid-svg-icons';

const Top = ({ onToggleSidebar, isSidebarExpanded, isSidebarHovered }) => {
	const shouldRotate = isSidebarExpanded || isSidebarHovered;
	const [isProfileVisible, setIsProfileVisible] = useState(false);

const profileRef = useRef(null);
	const toggleProfile = () => {
		setIsProfileVisible(prev => !prev);
	};
	
	return(
		<div className={`container-fluid top-nav d-flex align-items-center justify-content-between ${shouldRotate ? 'top-nav-shifted' : ''}`}>
			<div  className="top-nav-bar d-flex align-items-center" >
				<FontAwesomeIcon icon={faBars} size="lg" color="black" onClick={onToggleSidebar} style={{ cursor: 'pointer', transform: shouldRotate ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease'}} />
				<p className="ms-2 big-font">TASKBANANA</p>	

			</div>
			<div style={{position:"relative", height:"100%"}}>
					<p style={{padding:"20px", marginRight:"20px", cursor:"pointer"}}  onClick={toggleProfile}>{localStorage.getItem('firstname')} {localStorage.getItem('lastname')}  <FontAwesomeIcon icon={isProfileVisible ? faCaretUp : faCaretDown} size="sm" color="black"/></p>
					
					
					<CSSTransition
					  in={isProfileVisible}
					  timeout={100}
					  classNames="slide-profile"
					  unmountOnExit
					  nodeRef={profileRef} // Required to avoid findDOMNode error npm install react-transition-group
					>
						<div className="profile-container" ref={profileRef}>
						    <div style={{ marginBottom: "20px" }}>
						      <img src={localStorage.getItem('image') || 'img/profile.png'} width="100%" height="auto" />
						    </div>
						    <h4 className="col-md-12 text-center">{localStorage.getItem('firstname')} {localStorage.getItem('lastname')}</h4>
						    <p className="col-md-12 text-center" style={{ marginBottom: "20px" }}>
						      {localStorage.getItem('email')}
						    </p>
						    <div className="btn-group d-flex justify-content-center">
						      <a href="http://localhost/taskb_v2/en/profile/" target="_blank" className="btn btn-gray btn-profile">
						        <FontAwesomeIcon icon={faUser} /> Profile
						      </a>
						      <a className="btn btn-gray btn-profile">
						        <FontAwesomeIcon icon={faSignOut} /> Logout
						      </a>
						    </div>
						  </div>
					</CSSTransition>
			</div>
			
		</div>

	)
}

export default Top;